export const linkToCreateVolumeCustomReport = () =>
  `/app/volume/custom-reports/create`;
